/* <surisa-image-lightbox> — visor de imagen a pantalla completa reutilizable.

   Modal nativo <dialog> (showModal() aporta focus-trap, Esc y scroll-lock sin
   JS extra), tamaño fijo centrado, fondo papel. Componente ÚNICO de "ampliar"
   (Fix 9): lo usan la galería del PDP (surisa-product-gallery.js) y el techhero
   del catálogo (catalog-table.js). Cada host recoge SUS imágenes y llama
   .open(images, startIdx); el componente no conoce a sus hosts.

   API:
     el.open(images, startIdx)   images = [{ src, alt }]
     el.close()
     el.show(i)                  navega con wrap-around
     el.onClose = function (idx) {}   callback opcional al cerrar (sync del host)

   Markup esperado (snippet image-lightbox.liquid):
     [data-lightbox]          <dialog>
     [data-lightbox-img]      <img>
     [data-lightbox-counter]  contador "01 / 03"
     [data-lb-prev] [data-lb-next]   flechas (el JS las muestra/oculta por nº)
     [data-lightbox-close]    botón cerrar
*/
(function () {
  if (customElements.get('surisa-image-lightbox')) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  customElements.define('surisa-image-lightbox', class extends HTMLElement {
    connectedCallback() {
      this.dialog   = this.querySelector('[data-lightbox]');
      this.imgEl    = this.querySelector('[data-lightbox-img]');
      this.counter  = this.querySelector('[data-lightbox-counter]');
      this.prevBtn  = this.querySelector('[data-lb-prev]');
      this.nextBtn  = this.querySelector('[data-lb-next]');
      this.closeBtn = this.querySelector('[data-lightbox-close]');
      this.images   = [];
      this.idx      = 0;
      this.onClose  = null;
      if (!this.dialog || this._bound) return;
      this._bound = true;
      this._bind();
    }

    _bind() {
      var self = this;
      if (this.closeBtn) this.closeBtn.addEventListener('click', function () { self.close(); });
      if (this.prevBtn)  this.prevBtn.addEventListener('click',  function (e) { e.stopPropagation(); self.show(self.idx - 1); });
      if (this.nextBtn)  this.nextBtn.addEventListener('click',  function (e) { e.stopPropagation(); self.show(self.idx + 1); });

      // Click en el backdrop (área del <dialog> fuera del contenido) cierra.
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      // Esc → <dialog> emite 'cancel'; preventDefault + close() para disparar onClose.
      this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });

      document.addEventListener('keydown', function (e) {
        if (!self.dialog.open) return;
        if (e.key === 'ArrowRight') self.show(self.idx + 1);
        else if (e.key === 'ArrowLeft') self.show(self.idx - 1);
      });
    }

    open(images, startIdx) {
      if (!this.dialog || !images || !images.length) return;
      this.images = images;
      this.idx = startIdx || 0;
      var multi = images.length > 1;
      if (this.prevBtn) this.prevBtn.hidden = !multi;
      if (this.nextBtn) this.nextBtn.hidden = !multi;
      this._render();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    close() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else this.dialog.removeAttribute('open');
      if (typeof this.onClose === 'function') this.onClose(this.idx);
    }

    show(i) {
      var n = this.images.length;
      if (!n) return;
      this.idx = ((i % n) + n) % n;
      this._render();
    }

    _render() {
      var cur = this.images[this.idx];
      if (!cur) return;
      if (this.imgEl) { this.imgEl.src = cur.src; this.imgEl.alt = cur.alt || ''; }
      if (this.counter) this.counter.textContent = pad(this.idx + 1) + ' / ' + pad(this.images.length);
    }
  });
})();
